import type { ReactNode } from "react";
import { back } from "../lib/router";
import { telegram } from "../lib/telegram";
import { Icon } from "./Icon";

export function TopBar({ title, right, onBack = back }: { title?: string; right?: ReactNode; onBack?: () => void }) {
  // В Telegram «назад» — нативная кнопка в шапке, свою не рисуем
  const showBack = !telegram();
  return (
    <header className="topbar">
      {showBack ? (
        <button className="icon-btn" onClick={onBack} aria-label="Назад">
          <Icon name="back" />
        </button>
      ) : (
        <span />
      )}
      {title && <h1 className="topbar-title">{title}</h1>}
      <div className="topbar-right">{right}</div>
    </header>
  );
}

export function Segmented<T extends string | number>({
  value,
  options,
  onChange,
  label,
}: {
  value: T;
  options: { value: T; label: string; disabled?: boolean; hint?: string }[];
  onChange: (v: T) => void;
  label: string;
}) {
  return (
    <div className="segmented" role="radiogroup" aria-label={label}>
      {options.map((o) => (
        <button
          key={String(o.value)}
          role="radio"
          aria-checked={o.value === value}
          aria-disabled={o.disabled || undefined}
          disabled={o.disabled}
          title={o.hint}
          className={(o.value === value ? "seg on" : "seg") + (o.disabled ? " off" : "")}
          onClick={() => !o.disabled && onChange(o.value)}
        >
          {o.disabled && <span className="seg-spin" aria-hidden />}
          {o.label}
        </button>
      ))}
    </div>
  );
}

export function Field({ label, hint, children }: { label: string; hint?: string; children: ReactNode }) {
  return (
    <div className="field">
      <div className="field-label">{label}</div>
      {children}
      {hint && <div className="field-hint">{hint}</div>}
    </div>
  );
}

export function plural(n: number, one: string, few: string, many: string) {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return `${n} ${one}`;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return `${n} ${few}`;
  return `${n} ${many}`;
}

export function formatTime(sec: number) {
  const s = Math.max(0, Math.round(sec));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}
